import {Slide} from "react-slideshow-image";
import React from "react";

const JavascriptTutorialsSlides = () => {

    return(
        <div style={{borderRadius: "5px", color:"black", width: '100%', }}>

        <Slide >
            <div className="each-slide-effect " >

              <p style={{width:"100%" ,textAlign:"center",fontFamily:"Segoe UI", fontWeight:"700", fontSize:"1em", padding:"35px", color:"#100720"}}>
                  <em><strong> BECOME A FULLSTACK DEVELOPER THROUGH OUR SELF STUDY PLATFORM</strong></em>
              </p>

            </div>
            <div className="each-slide-effect">

                <p style={{width:"100%",textAlign:"center",fontFamily:"Segoe UI", fontWeight:"700",fontSize:"1em", padding:"35px",  color:"#100720"}}>
                 What you will learn covers : Frontend & Backend Application Developments
                </p>

            </div>
            <div className="each-slide-effect">

                <p style={{width:"100%",textAlign:"center",fontFamily:"Segoe UI", fontWeight:"700",fontSize:"1em", padding:"35px", color:"#100720"}}>
                    DevOp, Cloud Architect, and programing (Java, JavaScript, Python, Spring boot, Nodejs, React & Angular ).
                </p>

            </div>
        </Slide>
        </div>
    )
}

export default JavascriptTutorialsSlides;
